import React from 'react'
import SidebarHeader from '../Form/BackArrow/SidebarHeader'
import { Timeline } from "primereact/timeline";
const DealHistoryCard = ({
    events,
    handleDealHistoryBack,
    
}) => {
  return (
    <>
           <SidebarHeader onClick={handleDealHistoryBack} title={"Deal History"}/>
    
              <div>
                <Timeline
                  className=" mt-10 "
                  value={events}
                  opposite={(item) => (
                    <small className="text-color-secondary text-[12px] font-semibold w-full xl:text-[12px] whitespace-nowrap">
                      {item.timestamp}
                    </small>
                  )}
                  content={(item) => (
                    <small className="text-color-secondary text-[12px] font-semibold xl:text-[12px] w-full">
                      {item.log}
                    </small>
                  )}
                  marker={(item) => (
                    <span
                      className="custom-marker"
                      style={{ borderColor: "#399E79", borderWidth: "3px" }}
                    ></span>
                  )}
                />
              </div>
    </>
  )
}

export default DealHistoryCard